import React from 'react';
import { useReveal } from '../lib/useReveal';
import { trackCustom } from '../lib/pixel';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/1RrGSPsADtz5ojo4xLqmSN/MOCKUP_BIO.png';
const BENEFITS = [{
  icon: '📖',
  text: '6 Tomos Profesionales'
}, {
  icon: '🎁',
  text: '6 Recursos Prácticos'
}, {
  icon: '📜',
  text: 'Certificado Digital'
}, {
  icon: '⚡',
  text: 'Acceso Inmediato'
}, {
  icon: '💻',
  text: '100% Digital'
}];
const SOCIAL_PROOF = [{
  icon: '🏆',
  text: 'Formación práctica y organizada paso a paso'
}, {
  icon: '🌿',
  text: 'Aplicable desde la primera sesión'
}, {
  icon: '📜',
  text: 'Certificado digital incluido'
}];
export function HeroSection() {
  const [ref1, vis1] = useReveal();
  return <section className="pt-6 pb-8 md:pt-12 md:pb-14 px-4 sm:px-6 overflow-hidden relative flex flex-col justify-center bg-[#EFEAE0] border-b border-[#2E4F48]/10" data-id="element-191">
      <div ref={ref1} className={`reveal container mx-auto max-w-2xl relative z-10 text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-192">
        {/* Micro Headline */}
        <div className="mb-3 md:mb-4" data-id="element-193">
          <span className="text-[#1C3B36] text-[9px] md:text-xs font-bold tracking-[0.2em] uppercase bg-[#ffffff] border border-[#2E4F48]/20 rounded-full px-3.5 py-1.5 inline-flex items-center gap-1.5 shadow-sm" data-id="element-194">
            <span className="text-[#C2683D]" data-id="element-195">✨</span> FORMACIÓN PROFESIONAL EN
            BIODECODIFICACIÓN
          </span>
        </div>

        {/* Main Headline */}
        <h1 className="font-serif tracking-tight text-[#1C3B36] text-[26px] sm:text-3xl md:text-4xl lg:text-5xl mb-2.5 md:mb-4 max-w-2xl mx-auto font-[800] leading-[1.12]" data-id="element-196">
          APRENDÉ BIODECODIFICACIÓN DESDE CERO
        </h1>

        {/* Subheadline */}
        <p className="text-[#44574F] mb-4 md:mb-6 leading-relaxed text-sm md:text-base max-w-xl mx-auto font-medium" data-id="element-197">
          Comprendé el origen emocional de los síntomas, descubrí patrones
          ocultos y adquirí herramientas prácticas para acompañar procesos de
          transformación personal y terapéutica.
        </p>

        {/* Mockup — directly below subtitle, compact so the CTA stays visible on mobile */}
        <div className="flex justify-center mb-4 md:mb-6" data-id="element-198">
          <div className="relative w-full max-w-[190px] sm:max-w-[240px] md:max-w-[300px]" data-id="element-199">
            <div className="relative animate-float" data-id="element-200">
              <img src={PRODUCT_IMG} alt="Formación en Biodescodificación Integral" className="w-full object-contain block drop-shadow-[0_15px_30px_rgba(28,59,54,0.22)]" data-id="element-201" />
            </div>
          </div>
        </div>

        {/* Rating */}
        <div className="flex justify-center mb-4" data-id="element-202">
          <div className="flex items-center gap-2 bg-[#E8E0D3] border border-[#C2683D]/20 py-1.5 px-3.5 rounded-xl" data-id="element-203">
            <div className="flex gap-0.5 text-[#C2683D] text-sm" data-id="element-204">
              <span data-id="element-205">★</span>
              <span data-id="element-206">★</span>
              <span data-id="element-207">★</span>
              <span data-id="element-208">★</span>
              <span data-id="element-209">★</span>
            </div>
            <span className="text-[#1C3B36] font-bold text-xs sm:text-sm" data-id="element-210">
              4.9/5
            </span>
            <span className="text-[#44574F] text-xs sm:text-sm font-medium" data-id="element-211">
              · +800 alumnos de Latinoamérica
            </span>
          </div>
        </div>

        {/* CTA */}
        <div className="mb-5" data-id="element-212">
          <a href="#premium" onClick={e => {
          e.preventDefault();
          trackCustom('ViewPricingIntent', {
            source: 'hero'
          });
          const target = document.getElementById('oferta-box');
          if (!target) return;
          // Land on the offer card so includes, price and button are visible
          const rect = target.getBoundingClientRect();
          const margin = 24;
          let destination = rect.top + window.scrollY - (window.innerHeight - rect.height) / 2;
          // If the card is taller than the viewport, align its top with a small margin
          if (rect.height > window.innerHeight - margin * 2) {
            destination = rect.top + window.scrollY - margin;
          }
          const start = window.scrollY;
          const distance = destination - start;
          const duration = 550;
          let startTime: number | null = null;
          const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          const step = (now: number) => {
            if (startTime === null) startTime = now;
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            window.scrollTo(0, start + distance * easeInOutCubic(progress));
            if (progress < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 rounded-xl text-white font-bold text-sm md:text-base tracking-widest uppercase transition-all shadow-[0_10px_25px_rgba(28,59,54,0.25)] hover:shadow-[0_15px_35px_rgba(28,59,54,0.35)] hover:-translate-y-1 bg-[#2E4F48] hover:bg-[#1C3B36]" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-213">
            👉 QUIERO ACCEDER A LA FORMACIÓN
          </a>
          <p className="text-[#44574F] text-xs mt-2.5 font-bold" data-id="element-214">
            Acceso inmediato luego de completar tu compra.
          </p>
        </div>

        {/* Benefit chips — compact */}
        <div className="flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1.5 mb-5 max-w-xl mx-auto" data-id="element-215">
          {BENEFITS.map((benefit, i) => <span key={i} className="inline-flex items-center gap-1 bg-[#ffffff] border border-[#2E4F48]/15 rounded-full px-2.5 py-1 text-[#1C3B36] text-[10px] sm:text-[11px] font-bold shadow-sm" data-id="element-216">
              <span className="leading-none" data-id="element-217">{benefit.icon}</span>
              {benefit.text}
            </span>)}
        </div>

        {/* Social Proof Bullets */}
        <div className="flex flex-col items-center gap-2 max-w-md mx-auto" data-id="element-218">
          {SOCIAL_PROOF.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-219">
              <span className="text-sm leading-none mt-0.5" data-id="element-220">{item.icon}</span>
              <span className="text-[#1C3B36] text-xs sm:text-sm font-medium leading-snug" data-id="element-221">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}